import { useState } from 'react';
import axios, { AxiosRequestConfig, AxiosError } from 'axios';

type ApiState<T> = {
  loading: boolean;
  data: T | null;
  error: AxiosError | null;
};

type UsePostRequestOptions = {
  onError?: (error: AxiosError) => void;
};

export function usePostRequest<T = unknown, U = unknown>(options?: UsePostRequestOptions) {
  const [apiData, setApiData] = useState<ApiState<T>>({
    loading: false,
    data: null,
    error: null,
  });

  const submitApi = async (
    url: string,
    payload: U,
    withCredentials = false,
    headers: AxiosRequestConfig['headers'] = {}
  ) => {
    try {
      setApiData(prev => ({ ...prev, loading: true }));

      const response = await axios.post<T>(url, payload, {
        headers: {
          'Content-Type': 'application/json',
          ...headers,
        },
        withCredentials,
      });

      setApiData({ loading: false, data: response.data, error: null });
    } catch (error) {
      const axiosError = error as AxiosError;
      setApiData({ loading: false, data: null, error: axiosError });

      options?.onError?.(axiosError);
    }
  };

  return [submitApi, apiData] as const;
}
